export default {
  sm: `
  Today's
  records,
  tomorrow's
  innovations
  `,
  md: `
  Today's records,
  tomorrow's 
  innovations
  `,
};
